"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VendorUserProfileActions;
(function (VendorUserProfileActions) {
    VendorUserProfileActions["DataLoaded"] = "DataLoaded";
})(VendorUserProfileActions || (VendorUserProfileActions = {}));
exports.default = VendorUserProfileActions;
